import * as styles from "./css/Text.module.css";
import * as sharedStyles from "../css/Shared.module.css";
const Text = props => {
    return (<p class={`${styles.text} ${sharedStyles.shared}${props.class ? ` ${props.class}` : ``}`}>
            {props.children}
        </p>);
};
export { Text };
